module.exports = __webpack_public_path__ + "media/images/candidate-experience-mailer-survey-feedback-010cfb6fd49d89d38053355ac4bdc8c2.png";